module.exports = __webpack_public_path__ + "static/media/staffs.f653b9c8.png";